type ModalFormProps = {
  formUrl: string;
  width?: string;
  height?: string;
};

export const openModalForm = ({
  formUrl,
  width = '500px',
  height = '600px',
}: ModalFormProps) => {
  const modal = document.createElement('div');
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('tabindex', '-1');
  modal.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    z-index: 1000;
  `;

  const closeBtn = document.createElement('button');
  closeBtn.innerHTML = '×';
  closeBtn.style.cssText = `
    position: absolute;
    right: -16px;
    top: -16px;
    width: 32px;
    height: 32px;
    border: 2px solid #666;
    border-radius: 50%;
    background: #FFF;
    font-size: 20px;
    cursor: pointer;
  `;

  const iframe = document.createElement('iframe');
  iframe.src = formUrl;
  iframe.style.cssText = `width: ${width}; height: ${height}; border: none;`;

  const previousActiveElement = document.activeElement as HTMLElement;

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Tab') {
      const focusableElements = [closeBtn, iframe];
      const currentElement = document.activeElement as
        | HTMLButtonElement
        | HTMLIFrameElement
        | null;
      const currentIndex = currentElement
        ? focusableElements.indexOf(currentElement)
        : -1;

      e.preventDefault();

      if (e.shiftKey) {
        // If we're on the first element or outside the modal, go to the last
        if (currentIndex <= 0) {
          (
            focusableElements[focusableElements.length - 1] as HTMLElement
          ).focus();
        } else {
          (focusableElements[currentIndex - 1] as HTMLElement).focus();
        }
      } else {
        // If we're on the last element or outside the modal, go to the first
        if (currentIndex >= focusableElements.length - 1) {
          (focusableElements[0] as HTMLElement).focus();
        } else {
          (focusableElements[currentIndex + 1] as HTMLElement).focus();
        }
      }
    } else if (e.key === 'Escape') {
      closeModal();
    }
  };

  const closeModal = () => {
    modal.remove();
    overlay.remove();
    document.removeEventListener('keydown', handleKeyDown);
    previousActiveElement?.focus();
  };

  const overlay = document.createElement('div');
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 999;
  `;

  closeBtn.onclick = closeModal;
  overlay.onclick = closeModal;

  document.addEventListener('keydown', handleKeyDown);

  modal.appendChild(closeBtn);
  modal.appendChild(iframe);
  document.body.appendChild(overlay);
  document.body.appendChild(modal);

  (modal as HTMLElement).focus();

  iframe.onload = () => {
    iframe.setAttribute('tabindex', '0');
    // Force focus to close button after iframe loads
    closeBtn.focus();
  };
};
